export const Validator = {
    validate: (type: string, value: unknown): boolean => {
        if (typeof value === 'string') {
            switch (type) {
                case 'email':
                    return Boolean(
                        value.match(
                            /\b[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z.]{2,30}\b/i
                        )
                    );
                default:
                    return false;
            }
        }
        return false;
    },
};
